export const POSITIONS_ROUTES = {
  __ROOT__: '/positions',
}
